import React from "react";

/* eslint-disable max-len */
function PencilIcon() {
    return (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8 0L10 2L8.85355 3.14645L6.85355 1.14645L8 0ZM6.14645 1.85355L0 8V10H2L8.14645 3.85355L6.14645 1.85355Z" fill="#D6001C"/>
        </svg>
    );
}

export default PencilIcon;
